<script setup>
  import { computed } from 'vue';
  
  const props = defineProps({
    periodListData: { type: Array, default: () => [] },
    tableData: { type: Array, default: () => [] },
    version1ListData: { type: Array, default: () => [] },
    version2ListData: { type: Array, default: () => [] },
  });

  // 过滤出 count > 0 的版本数据
  const filteredVersion1List = computed(() => {
    return props.version1ListData.filter((item) => item.count > 0);
  });

  // 颜色数组，循环使用
  const versionColors = [
    'var(--accent-green)',
    'var(--accent-orange)',
    'var(--accent-blue)',
    'var(--accent-purple)',
    'var(--accent-pink)',
    'var(--brand-color)',
    'var(--accent-red)',
  ];

  // 获取颜色
  const getVersionColor = (index) => {
    return versionColors[index % versionColors.length];
  };
</script>
<template>
  <div style="margin-top: 5px;">
    <div class="detail-section-title">時間帯別（午前・午後・夜）</div>
    <div class="detail-row">
      <span class="detail-label">午前</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          // 计算百分比，保留1位小数
          width: (periodListData[0]?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
          background: 'var(--accent-blue)',
        }"></div>
      </div>
      <span class="detail-value">{{ (periodListData[0]?.count ?? 0).toLocaleString() }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">午後</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: (periodListData[1]?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
          background: 'var(--brand-color)',
        }"></div>
      </div>
      <span class="detail-value">{{ (periodListData[1]?.count ?? 0).toLocaleString() }}</span>
    </div>
    <div class="detail-row" style="border-bottom: none;">
      <span class="detail-label">夜</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: (periodListData[2]?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
          background: 'var(--accent-purple)',
        }"></div>
      </div>
      <span class="detail-value">{{ (periodListData[2]?.count ?? 0).toLocaleString() }}</span>
    </div>
    <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid var(--border-color);">
      <div class="detail-section-title">バージョン別</div>
      <!-- 循环version1List，只显示大于0的version数据 -->
      <template v-for="(item, index) in filteredVersion1List" :key="item.name || index">
        <div 
          class="detail-row" 
          :style="{ borderBottom: index === filteredVersion1List.length - 1 ? 'none' : '' }"
        >
          <span class="detail-label">{{ item.name }}</span>
          <div class="detail-bar-container">
            <div class="detail-bar" :style="{
              width: (item.count / (tableData[0]?.countTotal || 1) * 100).toFixed(1) + '%',
              background: getVersionColor(index),
            }"></div>
          </div>
          <span class="detail-value">{{ (item.count ?? 0).toLocaleString() }}</span>
        </div>
      </template>
    </div>
    <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid var(--border-color);">
      <div class="detail-section-title">字幕/吹替別（字幕・吹替・なし）</div>
      <div class="detail-row">
        <span class="detail-label">字幕</span>
        <div class="detail-bar-container">
          <div class="detail-bar" :style="{
            width: (version2ListData.find((item) => item.name === '字幕')?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
            background: 'var(--accent-blue)',
          }"></div>
        </div>
        <span class="detail-value">{{(version2ListData.find((item) => item.name ===
          '字幕')?.count)?.toLocaleString() }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">吹替</span>
        <div class="detail-bar-container">
          <div class="detail-bar" :style="{
            width: (version2ListData.find((item) => item.name === '吹替')?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
            background: 'var(--accent-pink)',
          }"></div>
        </div>
        <span class="detail-value">{{(version2ListData.find((item) => item.name === '吹替')?.count ??
          0).toLocaleString() }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">なし</span>
        <div class="detail-bar-container">
          <div class="detail-bar" :style="{
            width: (version2ListData.find((item) => item.name === 'なし')?.count / tableData[0]?.countTotal * 100).toFixed(1) + '%',
            background: 'var(--accent-purple)',
          }"></div>
        </div>
        <span class="detail-value">{{(version2ListData.find((item) => item.name === 'なし')?.count ??
          0).toLocaleString() }}</span>
      </div>
    </div>
  </div>
</template>